import { render, staticRenderFns } from "./common_edit.vue?vue&type=template&id=f44a9c90&scoped=true"
import script from "./common_edit.vue?vue&type=script&lang=js"
export * from "./common_edit.vue?vue&type=script&lang=js"
import style0 from "./common_edit.vue?vue&type=style&index=0&id=f44a9c90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44a9c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f44a9c90')) {
      api.createRecord('f44a9c90', component.options)
    } else {
      api.reload('f44a9c90', component.options)
    }
    module.hot.accept("./common_edit.vue?vue&type=template&id=f44a9c90&scoped=true", function () {
      api.rerender('f44a9c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/module_edit/common_edit.vue"
export default component.exports